import { cn } from "@/lib/utils"

/**
 * Skeleton — premium shimmer loading placeholder.
 *
 * Renders a soft rounded block with a diagonal gradient sweep animation
 * on top of a subtle pulse. Used for layout-matching skeleton screens.
 *
 * Props:
 *   className   — Tailwind classes for sizing (h-*, w-*, rounded-*, etc.)
 *   delay       — optional shimmer animation delay in ms (for stagger)
 *
 * Usage:
 *   <Skeleton className="h-4 w-32" />
 *   <Skeleton className="h-12 w-full" delay={100} />
 */
function Skeleton({ className, delay = 0, style, ...props }) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-primary/10",
        className
      )}
      style={{ ...style }}
      {...props}
    >
      <div
        className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/40 to-transparent dark:via-white/10"
        style={{ animationDelay: `${delay}ms` }}
      />
    </div>
  )
}

export { Skeleton }
